var App = App || {};

App.BlogSidebar = (function() {
  'use strict';

  var initialize = function() {
    _bindSelectNavigation();
    _bindMobileSearchToggle();
  };

  // This sends a query to the search page on a sidebar select change.
  var _bindSelectNavigation = function() {
    $(document).on('change', '.js-blog-sidebar-select-nav', function(e) {
      e.preventDefault();

      var thisQuery = $(this).val();

      window.location.href = thisQuery;
    });
  };

  var _bindMobileSearchToggle = function() {
    $(document).on('click', '.js-toggle-mobile-search-options', function(e) {
      e.preventDefault();

      $('.blog-sidebar-mobile-search-container').slideToggle();
    });
  }

  return {
    initialize: initialize
  };
}());

App.BlogSidebar.initialize();